module.exports = __webpack_public_path__ + "static/media/webIcons_cable-40.40d1479c.svg";